class TagCalendarFilter {
    constructor(element, actions, items, paginator, searchCounter=[]) {
        this.element = $(element)
        this.actions = $(actions)
        this.items = $(items)
        this.paginator = $(paginator)
        this.searchCounter = $(searchCounter)

        this.pubFilter = new PubFilter(this.element, this.actions, this.items, this.paginator, this.searchCounter);
        this.tag = $('#tag')
        this.calendar = $('#calendar')

        this.initListeners()
    }

    initListeners() {
        this.tag.on('submit', this.onTagSubmit.bind(this))
        this.calendar.on('submit', this.onCalendarSubmit.bind(this))
    }

    onTagSubmit(event) {
        event.preventDefault();
        $.magnificPopup.close();
        this.pubFilter.setState('tags', this.tagList);
        this.pubFilter.form.submit();
    }

    get tagList() {
        const items = $(this.tag).serializeArray();
        const values = [];

        for (let i = 0; i < items.length; i++) {
            values.push(items[i].value);
        }

        return values
    }

    onCalendarSubmit(event) {
        event.preventDefault();
        $.magnificPopup.close();
        this.setCalendar()
        this.pubFilter.form.submit();
    }

    setCalendar() {
        const date = this.pubFilter.form.find('input[name=calendar]')
        try {
            this.pubFilter.setState('calendar', JSON.parse(date.val()));
        } catch (error) {
            this.pubFilter.setState('calendar', {
                dates: [],
                view: 'days'
            });
        }
    }
}

